// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-pickup-wrap .thirty-padding {
  padding: 0 !important;
}
.stock-pickup-wrap .thirty-padding .cp-lg-obj-wrap {
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/inventory/stock-pickup/stock-pickup.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;AAAR;AACQ;EACI,qBAAA;AACZ","sourcesContent":[".stock-pickup-wrap{\n    .thirty-padding{\n        padding:0 !important;\n        .cp-lg-obj-wrap{\n            padding:0!important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
